// Kill switch for the free-plan "queue" upsell: when enabled, free users'
// generated videos (always) and images (2nd+ generation) are hidden behind a
// 45-minute "in queue" card with a Skip the Queue upgrade CTA — a client-side
// timer only; the media is actually ready. Unset/other = OFF: media shows as
// soon as it finishes. Toggle via Vercel env + redeploy.
export const FREE_MEDIA_QUEUE_ENABLED =
  process.env.NEXT_PUBLIC_FREE_MEDIA_QUEUE === 'true';
